import { render, staticRenderFns } from "./ServerLink.vue?vue&type=template&id=2089ae58&"
import script from "./ServerLink.vue?vue&type=script&lang=js&"
export * from "./ServerLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports